import type { AnswerInputProps } from '../QuestionRenderer'

export function SectionTitleBlock({ question }: AnswerInputProps<null>) {
  return (
    <div
      className="border-l-4 py-3 pl-5"
      style={{
        borderColor: 'var(--form-accent,#6366F1)',
        color: 'var(--form-answer,#475569)',
        fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
        textAlign: question.settings.layoutAlignment ?? 'left',
      }}
    >
      <div className="text-sm font-semibold uppercase tracking-normal opacity-70">Section</div>
      <div className="mt-2 text-base leading-7">
        {question.description || '接下來會進入新的題組，請依序完成。'}
      </div>
    </div>
  )
}
